module.exports = __webpack_public_path__ + "img/Karen-Arroyo-Moguel.14cf6568.png";